// extracted by mini-css-extract-plugin
export default {"label":"CreateVerificationModal-module__label--kTWRq","animatedBackground":"CreateVerificationModal-module__animatedBackground--P5wki"};